import React from 'react';

import { cssMap } from '@atlaskit/css';
import Image from '@atlaskit/image';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { type GhostIconConnector } from '../../../../../common/hooks/useGhostIconConnectors';
import { RovoLogoForAppSource } from '../../../../../common/ui/RovoLogoForAppSource';

const styles = cssMap({
	rovoLogoWrapper: {
		height: '20px',
		width: '20px',
		borderRadius: token('radius.xsmall'),
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		overflow: 'hidden',
	},
	placeholderLogo: {
		height: '20px',
		width: '20px',
		borderRadius: token('radius.large'),
		backgroundColor: token('color.background.accent.blue.subtle'),
	},
});

export const buildGhostIconNodes = (ghostConnectors: GhostIconConnector[]): React.ReactNode[] =>
	ghostConnectors.map((connector) =>
		fg('rovo_chat_use_be_knowledge_icons') ? (
			<Image
				key={connector.source}
				src={
					fg('use_new_knowledge_source_icon_url_prefix')
						? connector.iconUrl
						: `/gateway/api${connector.iconUrl}`
				}
				alt={connector.friendlyName}
				width={20}
				height={20}
			/>
		) : (
			<Box key={connector.source} xcss={styles.rovoLogoWrapper}>
				<RovoLogoForAppSource
					appSource={connector.source}
					rovoLogoProps={{ size: 'xsmall' }}
					fallback={<Box xcss={styles.placeholderLogo} />}
				/>
			</Box>
		),
	);
